import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './DistrictsList.css';

const DistrictFormInstances = () => {
  const { districtId } = useParams();
  const navigate = useNavigate();
  const [instances, setInstances] = useState([]);
  const [district, setDistrict] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  useEffect(() => {
    fetchDistrict();
    fetchInstances();
  }, [districtId]);

  const fetchDistrict = async () => {
    try {
      const response = await axios.get(`/api/districts/${districtId}`);
      setDistrict(response.data);
    } catch (error) {
      console.error('Failed to fetch district:', error);
    }
  };

  const fetchInstances = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/form-instances/district/${districtId}`);
      setInstances(response.data);
    } catch (error) {
      console.error('Failed to fetch form instances:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAssignment = async (instanceId) => {
    try {
      await axios.delete(`/api/form-instances/district/${districtId}/instance/${instanceId}`);
      setInstances(instances.filter(i => i.id !== instanceId));
      setDeleteConfirm(null);
    } catch (error) {
      console.error('Failed to delete form instance assignment:', error);
      alert('Failed to remove form instance from district');
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="districts-list">
      <div className="page-header">
        <div>
          <Link to="/superadmin/districts" style={{ marginBottom: '1rem', display: 'inline-block', color: '#3498db', textDecoration: 'none' }}>
            ← Back to Districts
          </Link>
          <h2>Form Instances for {district?.district_name || 'District'}</h2>
        </div>
      </div>

      {deleteConfirm && (
        <div className="modal-overlay" onClick={() => setDeleteConfirm(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Remove Form Instance</h3>
            <p>Are you sure you want to remove this form instance from this district? This will prevent parents in this district from seeing this form, but the form instance itself will not be deleted.</p>
            <div className="modal-actions">
              <button onClick={() => handleDeleteAssignment(deleteConfirm)} className="btn-danger">Remove</button>
              <button onClick={() => setDeleteConfirm(null)} className="btn-secondary">Cancel</button>
            </div>
          </div>
        </div>
      )}

      {instances.length === 0 ? (
        <div style={{ padding: '2rem', textAlign: 'center', background: 'white', borderRadius: '8px' }}>
          <p>No form instances assigned to this district.</p>
          <Link to="/superadmin/form-instances/create" className="btn-primary" style={{ marginTop: '1rem', display: 'inline-block' }}>
            Create Form Instance
          </Link>
        </div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Instance Name</th>
              <th>Master Form</th>
              <th>School Year</th>
              <th>Version</th>
              <th>Status</th>
              <th>Display Order</th>
              <th>Required</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {instances.map(instance => (
              <tr key={instance.id}>
                <td><strong>{instance.instance_name}</strong></td>
                <td>{instance.master_form_name}</td>
                <td>{instance.school_year || '-'}</td>
                <td>{instance.version_number}</td>
                <td>{instance.is_active ? 'Active' : 'Inactive'}</td>
                <td>{instance.display_order}</td>
                <td>{instance.is_required ? 'Yes' : 'No'}</td>
                <td>{new Date(instance.created_at).toLocaleDateString()}</td>
                <td className="actions">
                  <button 
                    onClick={() => navigate(`/superadmin/form-instances/${instance.id}`)} 
                    className="btn-edit"
                  >
                    View
                  </button>
                  <button 
                    onClick={() => setDeleteConfirm(instance.id)} 
                    className="btn-delete"
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default DistrictFormInstances;


